import ActionTypes from "../actionTypes/actionTypes";

/**
 * If true, it will trigger data reload when switch to WindowListView.
 * Otherwise, not reload data.
 * @description set reload after any window edit, CREAT/UPDATE/DELETE
 */
export default (state = {
    reload: true
}, action) => {
    switch (action.type) {
        case ActionTypes.SET_DATA_RELOAD : {
            return { 
                reload: !!action.reload
            };
        }
        default:
            return state
    }
}